"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIdempotentImpression = useIdempotentImpression;
var _react = require("react");
var _eventLogger = _interopRequireDefault(require("./eventLogger"));
function useIdempotentImpression(eventKey) {
  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _react.useEffect)(function () {
    if (eventKey) _eventLogger.default.track(eventKey, additionalData);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [eventKey]);
}